(function($) {
	$(function() {

		wp._lin_vimeo_players = wp._lin_vimeo_players || []

		let video_sections = document.getElementsByClassName('vimeo-section-video-inner');

		for ( var i = 0, len = video_sections.length; i < len; i++ ) {

			let videoID = video_sections[i].dataset.linVimeo;
			let options = {
				id: videoID,
				loop: true,
				autoplay: true,
				background: true,
				muted: true,
				responsive: true
			};

			let player = new Vimeo.Player(video_sections[i], options);
			wp._lin_vimeo_players[videoID] = player;

			let playerTimeline = document.getElementById('timeline-' + videoID );

			const SetProgressBarPosition = ({seconds, duration}) => {
				playerTimeline.style.width = (seconds + .25) / duration * 100 + '%';

				if ( seconds == 0 ){
					playerTimeline.style.transitionDuration = '0.1s';
					playerTimeline.style.width = '0%';
				} else {
					playerTimeline.style.transitionDuration = '.25s';
				}
			}

			player.on('timeupdate', SetProgressBarPosition);
			if ( i !== 0) {
				player.pause();
			}
		}

	});
})(jQuery);
